import { ChangeDetectionStrategy, Component } from '@angular/core';
import { 
  TypographyColor, 
  TypographyFontFamily, 
  TypographyFontSize 
} from '@design-system/components/atoms/typography/entities/typography.types';
import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import { ButtonIconSize } from '@design-system/components/molecules/button-icon/entities/button-icon.types';

@Component({
  selector: 'app-activities-ad-banner',
  templateUrl: './activities-ad-banner.component.html',
  styleUrls: ['./activities-ad-banner.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ActivitiesAdBannerComponent {

  public readonly iconCivitatis = Icon.Civitatis;
  public readonly iconFillColor = IconFillColor;
  public readonly buttonIconSize = ButtonIconSize.XXXL;
  public readonly fontFamily = TypographyFontFamily;
  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;
  
}
